import list from './list'
export default list